module.exports = __webpack_public_path__ + "public/media/marketeer-vector3.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/marketeer-vector3.png
// module id = ./images/services/marketeer-vector3.png
// module chunks = 0